
// var wx = require('weixin-js-sdk')
// const env = 'production';
const env = process.env.NODE_ENV;
const CryptoJS = require('./aes.js');
const key = CryptoJS.enc.Utf8.parse('q6%WF*1SvQx^YWzK');

export default {
  ua: navigator.userAgent,
  // 获取host
  getHost () {
    let host
    switch (env) {
      case 'test':
        host = 'http://alywechat.imcoming.com'
        break
      case 'production':
        host = 'https://alywechat.anlaiye.com'
        if (document.domain.indexOf('xiyoushi.com') >= 0) {
          host = window.location.origin
        }
        break
      default:
        host = 'http://alywechat.imcoming.com.cn'
    }
    return host
  },
  // 获取 拼接 host
  getSpliceHost (target) {
    let host
    switch (env) {
      case 'test':
        host = 'http://' + target + '.imcoming.com'
        break
      case 'production':
        // if(target == 'open-base'){
        //   target = 'web-agent';
        // }
        host = 'https://' + target + '.anlaiye.com'
        break
      default:
        host = 'http://' + target + '.imcoming.com.cn'
    }
    return host
  },
  // 获取 api agent host
  getAgentApiHost () {
    let host
    switch (env) {
      case 'test':
        host = 'http://open-base.imcoming.com'
        break
      case 'production':
        host = 'https://open-base.anlaiye.com'
        break
      default:
        host = 'http://web-agent.imcoming.com.cn'
    }
    return host
  },

  // 判断是否微信
  isWeiXin () {
    return this.ua.indexOf('MicroMessenger') > -1
  },
  // 判断是否企业微信
  isWxWork () {
    var ua = this.ua.toLowerCase();
    return ua.match(/MicroMessenger/i) == 'micromessenger' && ua.match(/wxwork/i) == 'wxwork'
  },

  // 判断是否是安卓
  platform(os) {
    var ver = ('' + (new RegExp(os + '(\\d+((\\.|_)\\d+)*)').exec(this.ua.toLowerCase()) || [, 0])[1]).replace(/_/g, '.');
    return parseFloat(ver) || undefined;
  },
  isAndroid() {
    return this.platform('android[/ ]');
  },
  // 二级域名下
  setCookie: function(name, value, days) {
    var domain, domainParts, date, expires, host;

    if (days)
    {
      date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    }
    else
    {
      expires = "";
    }

    host = location.host;
    if (host.split('.').length === 1)
    {
      // no "." in a domain - it's localhost or something similar
      document.cookie = name+"="+value+expires+"; path=/";
    }
    else
    {
      domainParts = host.split('.');
      domainParts.shift();
      domain = '.'+domainParts.join('.');

      document.cookie = name+"="+value+expires+"; path=/; domain="+domain;

      // check if cookie was successfuly set to the given domain
      // (otherwise it was a Top-Level Domain)
      if (this.getCookie(name) == null || this.getCookie(name) != value)
      {
        // append "." to current domain
        domain = '.'+host;
        document.cookie = name+"="+value+expires+"; path=/; domain="+domain;
      }
    }
  },
  getCookie (name) {
    var arr,reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)")
    if(arr=document.cookie.match(reg))
      return unescape(arr[2])
    else
      return null
  },
  // 解析地址
  resolveUrl: function () {
    var obj = {}
    var url = window.location.href
    if(url.indexOf('?') !== -1) {
      var param = url.split('?')[1]
      if(param.indexOf('&') === -1) {
        var pa = param.split('=')
        var paName = pa[0]
        var paValue = pa[1]
        obj[paName] = paValue
      } else {
        var paramsArry = param.split('&')

        for(var i=0; i<paramsArry.length; i++) {
          var pa = paramsArry[i].split('=')
          var paName = pa[0]
          var paValue = pa[1]
          obj[paName] = paValue
        }
      }
    }
    return obj
  },
  // 时间格式化
  getFormatTime (time) {
    var date = new Date(time);
    return date.getFullYear() + "." + (date.getMonth() + 1) + "." + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes();
  },

  wx_share (title, link, imgurl, desc) {
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    // 分享给微信好友
    wx.onMenuShareAppMessage({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      type: '', // 分享类型,music、video或link，不填默认为link
      dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
    // 分享给qq好友
    wx.onMenuShareQQ({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }

    });
    // 分享到微博
    wx.onMenuShareWeibo({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    });
      //分享到qq空间
    wx.onMenuShareQZone({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
      }
    })
  },
  wxShareNew (_this,title, link, imgurl, desc) {
    var u  = encodeURIComponent(window.location.href.split('#')[0]);
    let host = this.getAgentApiHost();
    if (env == 'local' || env == 'development') {
      host = host + '/wechatDev'
    } else {
      host = host + '/wechat'
    }
    let that = _this;
    that.$http.get(host + '/Jssdk/shareconf?url=' + u).then(function (res) {
      //var wxInfo = JSON.parse(redata.bodyText);
      if (res.flag == -1) {
        // alert(redata.message);
        return;
      }
      let data = res.body.data;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData','updateTimelineShareData'],
        openTagList: ['wx-open-launch-weapp']
      });
      wx.ready(function () {
        // 分享到朋友圈、qq空间
        wx.updateTimelineShareData({
          title: title, // 分享标题
          link: link, // 分享链接
          imgUrl: imgurl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });
        // 分享给微信好友、qq好友
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接
          imgUrl: imgurl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });
      })
      wx.error(function (res) {
        console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      })
    },function (data) {
      if(data.message){
        // alert(redata.message);
      }
    })
  },
  //去掉url后的某个参数
  funcUrlDel(name){
    var loca = window.location;
    var baseUrl = loca.origin + loca.pathname + "?";
    var query = loca.search.substr(1);
    if (query.indexOf(name)>-1) {
      var obj = {}
      var arr = query.split("&");
      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=");
        obj[arr[i][0]] = arr[i][1];
      };
      delete obj[name];
      var url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
      return url
    };
  },
  //在微信内修改url后点击用safari打开/复制链接是修改之前的页面
  share(route) {
    var replaceQueryParam = (param, newval, search) => {
      var regex = new RegExp('([?;&])' + param + '[^&;]*[;&]?')
      var query = search.replace(regex, '$1').replace(/&$/, '')
      return (
        (query.length > 2 ? query + '&' : '?') +
        (newval ? param + '=' + newval : '')
      )
    }

    if (!route.query.refresh) {
      var chat = '&'
      if (!Object.keys(route.query).length) {
        chat = '?'
      }
      window.location.replace(
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        replaceQueryParam('_wxr_', new Date().getTime(), location.search) +
        location.hash +
        chat + 'refresh=true'
      )
    }
  },
  toLogin(that,page){
    if(this.getCookie('source') === 'iaaa'){ //调转北大登录
      let hostStr = window.location.host;
      let host = hostStr.replace('alywechat','open-base');
      let url = location.protocol +'//'+ host + '/' + 'iaaa/auth/callback?openId='+that.$store.state.wxToken;
        // <input type=hidden name='redirectUrl' value='http://web-agent.imcoming.com/iaaa/auth/callback?openId=${that.$store.state.wxToken}'>
      document.write(
        `<form action='https://iaaa.pku.edu.cn/iaaa/oauth.jsp' method=post name='formx1' style='display:none'>
              <input type=hidden name='appID' value='Alyxndc2020'>
              <input type=hidden name='appName' value='俺来也校内订餐'>
              <input type=hidden name='redirectUrl' value='${url}'>
          </form>`
      );
      setTimeout("document.formx1.submit();",1000);
    } else if(this.getCookie('source') !== 'iaaa' && page !== 'index'){
      that.$router.push({name:'Login'})
    }
  },
  // 获取设备号
  setupWebViewJavascriptBridge (callback) {
    if (window.WebViewJavascriptBridge) {
      return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
      return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
      document.documentElement.removeChild(WVJBIframe)
    }, 0)
  },
  firstLogPush(size, arr, code, key) {
    size = size ? size : 0;
    let uid = localStorage.getItem('wxUid');
    let exposureLog = JSON.parse(localStorage.getItem('exposureLog'));
    exposureLog = exposureLog ? exposureLog : [];
    let list = new Array(), idx = 0;
    if (size > arr.length) {
      idx = arr.length - 1;
      list = arr;
    } else {
      list = arr.slice(0, size);
      idx = size -1;
    }
    // console.log(list)
    // console.log(key)
    for(let i=0;i<list.length;i++) {
      exposureLog.push({
        uid: uid,
        firstValue: i,
        // shopid: list[i][key],
        refId: list[i][key],
        createTime: new Date().getTime(),
        code: code,
      })
    }
    localStorage.getItem('recordLogIdx', idx);
    localStorage.setItem('lastLogTime', new Date().getTime());
    localStorage.setItem('exposureLog', JSON.stringify(exposureLog));
  },
  // aes 加密
  Encrypt(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString().toUpperCase();
  },
  // aes解密
  Decrypt(word) {
    if (!word) {
      return '';
    } else {
      var encryptedHexStr = CryptoJS.format.Hex.parse(word);
      var decrypt = CryptoJS.AES.decrypt(encryptedHexStr, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypt);
    }
  },
}




// WEBPACK FOOTER //
// ./src/common/utils.js